module.exports = __webpack_public_path__ + "img/clebs.a7fb5bc8.jpg";